import { Position } from '../../types/protocol.js';
import { ControlValues, SpcOverrides } from '../../types/spc.js';
import { getToleranceRange } from '../../utils/getToleranceRange.js';
import { calcMean, calcStddev, roundToPrecision } from '../../utils/mathUtils.js';


export function getControlValues(
    values: string[],
    position: Position,
    overrides?: SpcOverrides,
): ControlValues {
    const valuesAsNumbers = values
        .filter(it => it !== '')
        .map(it => parseFloat(it));

    const shouldLimitValues = overrides?.minValue != null || overrides?.maxValue != null;
    const finalValues = shouldLimitValues ?
        valuesAsNumbers.map(it => clampValue(it, overrides?.minValue, overrides?.maxValue))
        : valuesAsNumbers;

    const mean = overrides?.mean ?? calcMean(finalValues);
    const stddev = overrides?.stddev ?? calcStddev(finalValues);
    const { min, max } = getToleranceRange(position);

    return {
        nominal: position.nominal!,
        mean: round(mean),
        stddev: round(stddev),
        tolerances: [min, max],
        sigma1: [round(mean - stddev), round(mean + stddev)],
        sigma2: [round(mean - 2 * stddev), round(mean + 2 * stddev)],
        sigma3: [round(mean - 3 * stddev), round(mean + 3 * stddev)],
    }
}

function clampValue(value: number, min?: number, max?: number): number {
    if (min != null && value < min) {
        return min;
    }
    if (max != null && value > max) {
        return max;
    }
    return value;
}

function round(value: number): number {
    return roundToPrecision(value, 3);
}
